import { useMemo } from 'react'
import { Server } from 'lucide-react'
import type { AdminColumn } from '@/components/DataTable/types'
import { GeoRegistryTable } from './GeoRegistryTable'
import { GEO_STR as S, type GeoConfigRow } from './geoApi'

/**
 * A11.16 — Hudud bo'yicha DC yo'naltirish. Har davlat uchun bitta data-markaz
 * (davlat → DC nomi). JONLI CRUD (upsert): `/admin/geo/dc-routes`.
 */
export function DcRoutingScreen() {
  const columns = useMemo<AdminColumn<GeoConfigRow>[]>(
    () => [
      { key: 'country_code', header: S.code, type: 'id', width: 90 },
      { key: 'dc_name', header: S.dcNameCol, type: 'text', minWidth: 200 },
    ],
    [],
  )

  return (
    <GeoRegistryTable
      screenId="A11.16"
      title={S.dcTitle}
      description={S.dcNote}
      addLabel={S.addDcRoute}
      path="/admin/geo/dc-routes"
      listKey="routes"
      searchKeys={['country_code', 'dc_name']}
      fields={[
        { name: 'country_code', placeholder: S.code },
        { name: 'dc_name', placeholder: S.dcNameCol },
      ]}
      columns={columns}
      icon={<Server size={28} strokeWidth={1.5} />}
    />
  )
}
